<template>
  <div class="wrapper-login">
    <div class="login-box">
      <div class="login-logo">
        <p class="text-center">
          <img
            src="/img/icon.png"
            alt="Logo"
          >
        </p>
      </div>
      <div class="login-box-body">
        <p class="login-box-msg">
          {{ $t('string.login') }} <br><b>CashHero</b>
        </p>
        <div
          v-if="isLoginFail"
          class="alert alert-danger alert-dismissible"
          role="alert"
        >
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          {{ messageLoginFail }}
        </div>
        <div
          v-if="expiredSession"
          class="alert alert-info alert-dismissible"
          role="alert"
        >
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          {{ $t('stings.yourSessionHaveBeenExpired!') }}
        </div>
        <form
          action="javascript:void(0)"
          method="post"
        >
          <div
            class="form-group"
            :class="{'has-error' : validations['username']}"
          >
            <input
              type="text"
              v-model="credentials.username"
              class="form-control"
              :placeholder="$t('label.username')"
            >
            <span
              class="label-error"
              v-if="validations['username']"
            >
              {{ validations['username'][0] }}
            </span>
          </div>
          <div
            class="form-group"
            :class="{'has-error' : validations['password']}"
          >
            <input
              type="password"
              class="form-control"
              v-model="credentials.password"
              :placeholder="$t('label.password')"
            >
            <span
              class="label-error"
              v-if="validations['password']"
            >
              {{ validations['password'][0] }}
            </span>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <button
                class="btn btn-primary btn-block btn-flat"
                @click="onClickLogin"
              >
                <i class="fa fa-sign-in" /> {{ $t('button.signin') }}
              </button>
              <br>
            </div>
          </div>
        </form>
        <p class="text-center">
          &copy; {{ $t('string.copyright') }} <b>Cash Hero Financial Co., Ltd</b>
        </p>
      </div>
    </div>
    <div class="version">
      អភិវឌ្ឍន៍ដោយ <a
        href="https://asorasoft.com"
        target="_blank"
      >Asorasoft.com</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Login',
  metaInfo () {
    return {
      title: this.$t('string.login'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.main,
      expiredSession: state => state.auth.expiredSession
    })
  },
  data () {
    return {
      appName: process.env.VUE_APP_NAME,
      credentials: {
        username: '',
        password: ''
      },
      validations: {},
      isLoginFail: false,
      messageLoginFail: this.$t('stings.usernameOrPasswordIsIncorrect!')
    }
  },
  methods: {
    onClickLogin (e) {
      e.preventDefault()
      this.$store.commit('auth/setExpiredSession', false)
      this.validations = {}
      this.isLoginFail = false
      this.$isLoading(true)
      const self = this
      this.$axios.post(process.env.VUE_APP_API + '/api/auth/backend/login', this.credentials)
        .then(({ data }) => {
          if (data.data) {
            window.removeEventListener('keyup', this.onPressEnter)
            const {
              access_token,
              refresh_token,
              user,
              roles,
              permissions
            } = data.data

            localStorage.setItem(this.$token, access_token)
            localStorage.setItem(process.env.VUE_APP_REFRESH_TOKEN, refresh_token)

            self.$axios.defaults.headers.common.Authorization = 'Bearer ' + access_token
            self.$axios.defaults.headers.common.Accept = 'application/json'

            self.$store.dispatch('user/setUser', { user })
            self.$store.dispatch('user/setRoles', roles)
            self.$store.commit('user/setPermissions', permissions)

            // set ajax request headers
            $.ajaxSetup({
              headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem(this.$token)
              }
            })

            this.$router.push({
              path: localStorage.getItem('fromRoutePath') || '/admin/dashboard'
            })
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.status &&
            error.response.status === 422
          ) {
            self.validations = error.response.data.errors
          } else {
            this.isLoginFail = true
            if (error.response && error.response.data && error.response.data.message) {
              let message = error.response.data.message
              if (message.message_en || message.message_km) {
                message = message['message_' + this.$i18n.locale]
              }
              this.messageLoginFail = message
            }
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    onPressEnter (e) {
      if (e.code === 'Enter') {
        this.onClickLogin(e)
      }
    }
  },
  mounted () {
    this.$isLoading(false)
    window.addEventListener('keyup', this.onPressEnter)
  }
}
</script>

<style>
.login-box {
  width: 420px !important;
  border: 1px solid #f1f1f1;
}

.login-logo {
  padding: 10px;
  border-bottom: 1px solid #f1f1f1;
  display: flex;
  align-content: center;
  justify-content: center;
}

.login-logo a {
  color: #fff !important;
}

.login-logo img {
  max-width: 70%;
}

.wrapper-login {
  height: 100vh !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.version {
  position: absolute;
  bottom: 10px;
  right: 10px;
  padding: .2rem 1.6rem .2rem;
  color: #888;
  font-weight: 700;
}

.login-box-body {
  padding-top: 0 !important;
}
</style>
